import { CONFIG } from 'src/config';
import { FullName, getFullName } from 'src/shared/utils';

export const sorterByFullName = ({ lastNameFirst }: { lastNameFirst?: boolean }) => (
  item1: FullName,
  item2: FullName,
): number => getFullName({ item: item1, lastNameFirst })
  .localeCompare(getFullName({ item: item2, lastNameFirst }), CONFIG.LOCALE);
